// Organization slice - matching admin-web structure
import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { setUser, resetAuth } from '../authSlice';
import { PURGE } from 'redux-persist';

export interface IOrganizationState {
  organizationId: number;
  domain: string;
  id?: number;
  name?: string;
  contactPerson?: string;
}

const initialState: IOrganizationState = {
  organizationId: 0,
  domain: '',
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    reset: () => initialState,
    setOrganization: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(PURGE, () => {
        return initialState;
      })
      .addCase(setUser, (state, { payload }) => {
        const user: any = payload;
        
        if (!user || !user.roles || user.roles.length === 0) {
          return initialState;
        }

        // Get organization from first role (matching admin-web logic)
        const firstRole = user.roles[0];
        const organization = firstRole.organization;

        if (!organization) {
          return initialState;
        }

        return {
          organizationId: organization.id,
          domain: organization.domain || organization.name || '',
          id: organization.id,
          name: organization.name,
          contactPerson: organization.contactPerson,
        };
      })
      .addCase(resetAuth, () => {
        return initialState;
      });
  },
});

export const { reset, setOrganization } = organizationSlice.actions;

export default organizationSlice.reducer;

